import { dataFetched } from 'data/graphql'
import OrganizationsAPI from 'remote/organizations'
import { FETCH_MY_ORGANIZATION_CONTACTS } from './actionTypes'

export const fetchMyOrganizationContacts = name => ({
  getState,
  dispatch,
  graphQLClient,
}) => {
  return {
    type: FETCH_MY_ORGANIZATION_CONTACTS,
    payload: {
      promise: graphQLClient
        .query({
          query: OrganizationsAPI.fetchMyOrganizationContacts,
          variables: {
            name,
          },
        })
        .then(({ data }) => {
          dispatch(dataFetched(data.me.organization.contacts))
        }),
    },
  }
}
